var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"text-center",attrs:{"align":"center","justify":"center"}},[_c('v-btn',{staticClass:"ml-0 mt-4 pl-0 mr-6"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"data":_vm.data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":"ข้อมูลตามประเภทข้อมูล.xls","header":'ข้อมูลตามประเภทข้อมูลทั้งหมด' +
        ' ระหว่างวันที่ ' +
        _vm.formDate +
        ' ถึง ' +
        _vm.toDate}},[_c('img',{attrs:{"src":require("@/assets/Excel-Logo.png"),"width":"50px"}}),_vm._v(" Export ข้อมูลตามประเภทข้อมูล ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }